import { render, staticRenderFns } from "./fluxPollDetail.vue?vue&type=template&id=afc26c3a&scoped=true&"
import script from "./fluxPollDetail.vue?vue&type=script&lang=js&"
export * from "./fluxPollDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc26c3a",
  null
  
)

export default component.exports